import { FullScreenLoading } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useGetUserCollegesQuery } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.api';

import { Typography } from '@mui/material';

import { MyCollegesPage } from './MyCollegesPage';

export const MyCollegesPageContainer = () => {
  const { data, isLoading } = useGetUserCollegesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return <FullScreenLoading />;
  }

  if (!data) {
    return (
      <Typography variant="text-md-regular">{appStrings.modules.myColleges.loadFailed}</Typography>
    );
  }

  return <MyCollegesPage data={data} />;
};
